import { html, nothing, render } from "lit-html";
import { data } from "@escapio/shared/state/payload";
import { templateImage } from "@escapio/portal/components/ads/partner-banner";
import { SIZE_TABLET } from "@escapio/portal/dom/screen";
import connect from "@escapio/shared/data-store/connect";
import { store } from "./DataStore";
import { PROVIDER_ESCAPIO } from "@escapio/portal/api/provider-codes";

customElements.define(
	"esc-sunnycars-banner",
	class extends connect(HTMLElement, store) {
		update(state) {
			let template = nothing;
			if (state?.prices?.offers?.[0]?.provider != PROVIDER_ESCAPIO) {
				template = templateImage(
					"Hotel",
					"Sunnycars",
					`${this.hotelId} | ${this.hotelName}`,
					"https://www.sunnycars.de/?ak=736993",
					html`<picture>
						<source
							media="(min-width: ${data.grid[SIZE_TABLET][0]}px)"
							srcset="/public/img/portal/sunnycars-banner-20250409.png"
						/>
						<img
							src="/public/img/portal/sunnycars-banner-20250409-mobile.png"
						/>
					</picture>`,
				);
			}
			render(template, this, { host: this });
		}

		get hotelId() {
			return this.getAttribute("hotel-id");
		}

		get hotelName() {
			return this.getAttribute("hotel-name");
		}
	},
);
